import { createSlice } from "@reduxjs/toolkit";

//STATE
const state = {
  showDialog: false,
  isLoading: false,
  itemPhotosAdd: {},
};

//STORE SLICE
export const itemPhotosAddSlice = createSlice({
  name: "itemPhotosAddSlice",
  initialState: state,
  //REDUCER
  reducers: {
    showAddItemPhotosDialog(state) {
      return {
        ...state,
        showDialog: true,
      };
    },
    getItemData(state, action) {
      return {
        ...state,
        itemPhotosAdd: action.payload,
      };
    },
    closeAddItemPhotosDialog(state) {
      return {
        ...state,
        showDialog: false,
      };
    },
    showLoading(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    hideLoading(state) {
      return {
        ...state,
        isLoading: false,
      };
    }, 
  },
});

//ACTIONS
export const {
  showAddItemPhotosDialog,
  getItemData,
  closeAddItemPhotosDialog,
  showLoading,
  hideLoading,
} = itemPhotosAddSlice.actions;

export default itemPhotosAddSlice.reducer;
